<template>
  <div class="vote">
    <NavBar />
    <iframe
      src="https://unadulterated-fort.000webhostapp.com/hiscores/"
      frameBorder="0"
      scrolling="no"
      class="hiscores"
    ></iframe>
    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
import NavBar from "../components/Navbar/Navbar.vue";
import Footer from "../components/Footer/Footer.vue";

export default {
  components: {
    NavBar,
    Footer,
  },
};
</script>


<style scoped>
iframe {
  width: 100%;
  height: 175vh;
  overflow-y: scroll; /* Add the ability to scroll */
}
.hiscores::-webkit-scrollbar {
  display: none;
}
.hiscores {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  iframe {
    height: 200vh;
  }
}
/* Small devices (portrait tablets and large phones, 600px and up) */
@media(max-width: 700px) {
  iframe {
    height: 230vh;
  }
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (max-width: 1500px) {
    iframe {
    height: 283vh;
  }
}
</style>